/* eslint-disable react/display-name */
import RecoverController from './recoverController'

export default RecoverController
